import type { Resource } from '../../';
export const general_errors_renderAlerts_errorMsg: Resource = {"default":"Message"};
